import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {IncomingInventoryService} from 'app/blocks/service/api/incoming-inventory.service';
import {Resource} from 'app/constants/resource';

import {ENTITIES_SETUP_BASE_URL} from 'app/app.constants';
import {IIncomingInventory} from 'app/blocks/model/inventory-movement.model';
import {EntityNavigator} from 'app/blocks/routing/navigator';
import {IncomingInventory} from 'app/blocks/model/inventory-movement.model';
import {EntityUrlProvider} from 'app/blocks/routing/entity-url-provider';
import {AbstractEntityResource} from 'app/blocks/resource/abstract-entity-resource';

@Injectable({
    providedIn: 'root'
})
export class IncomingInventoryResource extends AbstractEntityResource<IIncomingInventory> {
    constructor(incomingInventoryService: IncomingInventoryService, router: Router) {
        super(
            Resource.INCOMING_INVENTORIES,
            incomingInventoryService,
            new EntityNavigator(ENTITIES_SETUP_BASE_URL, Resource.INCOMING_INVENTORIES, router),
            new EntityUrlProvider(ENTITIES_SETUP_BASE_URL, Resource.INCOMING_INVENTORIES),
            (entity?) => new IncomingInventory(entity),
            (entity) => entity.documentRef,
            'store'
        );
    }
}
